import { api } from "../api";
import { useSceneStore } from "../stores/sceneStore";

/** Recompile the active SpaceDescriptor into a SceneDescriptor (works outside React) */
export async function recompileActiveSpace(): Promise<void> {
  const { activeSpaceDescriptor, setScene } = useSceneStore.getState();
  if (!activeSpaceDescriptor) return;

  try {
    const { sceneDescriptor } = await api.compileDescriptor(
      activeSpaceDescriptor,
    );
    // Preserve the current selection so live edits (e.g. light presets,
    // terrain/conditions changes) don't deselect the active object.
    setScene(sceneDescriptor, { preserveSelection: true });
  } catch (err) {
    console.warn("[recompileScene] Failed to recompile:", err);
  }
}
